import {isStringValidInteger} from '@netx/core-next/utils/string';
import {keywordSearchSuggestionsEnabled} from '@netx/core-search-next/enablers';
import {SearchRules, SearchTypeKeyword, SearchTypeMetadata} from '../rules';

export const areSearchRulesForAssetIdSimpleSearch = (rules: SearchRules) => {
	if (!keywordSearchSuggestionsEnabled() || rules.elementTypes.length !== 2)
		return false;

	const metadataRuleIndex = rules.elementTypes.findIndex(
		(elementType) => elementType === SearchTypeMetadata,
	);
	if (metadataRuleIndex < 0) return false;

	const metadataRuleAttribute = rules.elementValue2s[metadataRuleIndex];
	// assetId -> objectId ¯\_(ツ)_/¯
	if (!['assetId', 'objectId'].includes(metadataRuleAttribute as string))
		return false;

	const keywordRuleIndex = rules.elementTypes.findIndex(
		(elementType) => elementType === SearchTypeKeyword,
	);
	if (keywordRuleIndex < 0) return false;

	const keywordRuleValue = rules.elementValue1s[keywordRuleIndex];
	const metadataRuleValue = rules.elementValue1s[metadataRuleIndex];

	return (
		isStringValidInteger(keywordRuleValue) &&
		keywordRuleValue.toString() === metadataRuleValue.toString()
	);
};
